import ApplicationController from '@aha-app/mvc';

export interface RecordValue {
  text: string;
  value: string;
  avatar?: string;
  initials?: string;
  link?: {
    url: string;
    drawer: boolean;
    new_tab: boolean;
  };
  color?: string;
  tooltip?: string;
}

export interface RecordSelectorProps {
  className?: string;
  editable?: boolean;
  value: RecordValue[];
  selectroProps: any;
  url: string;
  object: string;
  field: string;
}

interface State {
  records: RecordValue[];
  customFieldDefinitionType: string;
  url: string;
  object: string;
  field: string;
}

export class CustomRecordSelectorController extends ApplicationController<
  State,
  RecordSelectorProps
> {
  async initialize(props: RecordSelectorProps) {
    this.state.url = props.url;
    this.state.object = props.object;
    this.state.field = props.field;
  }

  actionChangeRecords(value: RecordValue[]) {
    let newRecords: Array<string | number> = value.map(record => record.value);
    // If we want to remove all records, we need to send a single [-1] value
    // Reference: https://github.com/aha-app/aha-app/blob/ceb864667e8d29fd0ec9d4ee5715cbd9fa5c5f17/app/controllers/custom_field_records_controller.rb#L28-L31
    if (newRecords.length < 1) {
      newRecords = [-1];
    }

    const objectField = `${this.state.object}[${this.state.field}][]`;
    const field = `${this.state.field}[]`;

    const formData = new FormData();
    for (const record of newRecords) {
      formData.append(objectField, record as string);
      formData.append(field, record as string);
    }

    fetch(this.state.url, {
      method: 'PUT',
      headers: {
        'X-CSRF-Token': window.csrfToken(),
      },
      body: formData,
    });
  }
}
